module.exports = __webpack_public_path__ + "static/workshop-76c7fe1f5cc28cdf372d2d638c45b20e.jpg";